import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, breadcrumbs = [], children }) => {
    return (
        <section className="relative overflow-hidden">
            <div className="absolute inset-0 hero-wash pointer-events-none" />
            <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 pt-12 pb-10 sm:pt-16 sm:pb-12">
                {breadcrumbs.length > 0 && (
                    <nav className="text-xs text-foreground/60 mb-4">
                        <ol className="flex flex-wrap items-center gap-1">
                            {breadcrumbs.map((bc, i) => (
                                <li key={`${bc.label}-${i}`} className="flex items-center gap-1">
                                    {bc.to ? (
                                        <Link
                                            to={bc.to}
                                            className="hover:text-terracotta"
                                        >
                                            {bc.label}
                                        </Link>
                                    ) : (
                                        <span className="text-foreground/80">
                                            {bc.label}
                                        </span>
                                    )}
                                    {i < breadcrumbs.length - 1 && (
                                        <ChevronRight className="h-3 w-3 text-foreground/40" />
                                    )}
                                </li>
                            ))}
                        </ol>
                    </nav>
                )}
                {eyebrow && (
                    <p className="font-accent text-xs text-terracotta mb-2">
                        {eyebrow}
                    </p>
                )}
                <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.05] text-moss">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-4 max-w-2xl text-base sm:text-lg text-foreground/80 leading-relaxed">
                        {subtitle}
                    </p>
                )}
                {children && <div className="mt-6">{children}</div>}
            </div>
        </section>
    );
};

export default PageHeader;
